import React from "react";
import RejectedOrderModificationComponent from "components/RejectedOrderModification/RejectedOrderModification";

const RejectedOrderModification = () => {
  return <RejectedOrderModificationComponent />;
};

export default RejectedOrderModification;

